import { UIElement, UIElementTypes } from '../element';
import SliderUiListElement from './SliderUiListElement.svelte';
import '../../types';
import { createBangleJSUiCode } from './bangleCode';
import { elementSelectionStore } from '../../stores/elementsSelection';
import { SCREEN_HEIGHT, SCREEN_WIDTH } from '../../constants';
export class UISlider extends UIElement {
    constructor(args) {
        super(UIElementTypes.SLIDER, args.x, args.y, args.z, args.name, args.id);
        this.group = args.group;
        this.length = args.length;
        this.vertical = args.vertical;
        this.sliderSize = args.sliderSize;
        this.sliderPosition = args.sliderPosition;
        this.sliderHitBoxOffset = args.sliderHitBoxOffset;
        this.sliderShowHitBox = args.sliderShowHitBox;
    }
    convertToCode() {
        const sliderLimits = {
            start: {
                x: this.x,
                y: this.y,
            },
            end: {
                x: this.x + (this.vertical ? 0 : this.length),
                y: this.y + (this.vertical ? this.length : 0),
            }
        };
        return createBangleJSUiCode(this.x, this.y, this.z, this.getRenderBox(), this.name, this.x, this.y, this.length, this.sliderPosition, this.sliderSize, this.vertical, this.sliderHitBoxOffset);
    }
    shouldScaleBeAdjusted(capturedEvent, eventValue) {
        return ['drag', 'rotate'].indexOf(eventValue.action) == -1 && capturedEvent !== 'moving';
    }
    convertToUiElement(mountPoint, uiElement, origin) {
        return new SliderUiListElement({ target: mountPoint, props: { uiElement, origin } });
    }
    renderElement(ctx, originCords) {
        const selected = elementSelectionStore.isSelected(this);
        const x = this.x + originCords.x;
        const y = this.y + originCords.y;
        const color = selected ? 'green' : 'black';
        const linePath = new Path2D();
        linePath.moveTo(x, y);
        linePath.lineTo(x + (this.vertical ? 0 : this.length), (this.vertical ? this.length : 0) + y);
        linePath.closePath();
        ctx.strokeStyle = color;
        ctx.stroke(linePath);
        ctx.fill(linePath, 'evenodd');
        const circlePath = new Path2D();
        const sliderCirclePosition = {
            x: x + (this.vertical ? 0 : this.length) * this.sliderPosition,
            y: y + (this.vertical ? this.length : 0) * this.sliderPosition,
        };
        circlePath.moveTo(sliderCirclePosition.x, sliderCirclePosition.y);
        circlePath.arc(sliderCirclePosition.x, sliderCirclePosition.y, this.sliderSize, 0, 2 * Math.PI);
        ctx.fillStyle = color;
        ctx.fill(circlePath, 'evenodd');
        if (this.sliderShowHitBox) {
            const hitBoxPath = new Path2D();
            hitBoxPath.moveTo(sliderCirclePosition.x + this.sliderSize + this.sliderHitBoxOffset, sliderCirclePosition.y);
            hitBoxPath.arc(sliderCirclePosition.x, sliderCirclePosition.y, this.sliderSize + this.sliderHitBoxOffset, 0, 2 * Math.PI);
            ctx.strokeStyle = 'blue';
            ctx.stroke(hitBoxPath);
        }
    }
    isSelected(pointerX, pointerY) {
        const start = {
            x: this.x - (this.vertical ? this.sliderSize : 0),
            y: this.y - (this.vertical ? 0 : this.sliderSize),
        };
        const end = {
            x: this.x + (this.vertical ? this.sliderSize : this.length),
            y: this.y + (this.vertical ? this.length : this.sliderSize),
        };
        return pointerX >= start.x && pointerX <= end.x && pointerY >= start.y && pointerY <= end.y;
    }
    moveElement(deltaX, deltaY) {
        this.x += deltaX;
        this.y += deltaY;
    }
    get isOutsideOfScreenArea() {
        const start = {
            x: this.x - (this.vertical ? this.sliderSize : 0),
            y: this.y - (this.vertical ? 0 : this.sliderSize),
        };
        const end = {
            x: this.x + (this.vertical ? this.sliderSize : this.length),
            y: this.y + (this.vertical ? this.length : this.sliderSize),
        };
        return start.x >= SCREEN_WIDTH || start.y >= SCREEN_HEIGHT || end.x <= 0 || end.y <= 0;
    }
    getRenderBox() {
        return {
            tl: { x: this.x, y: this.y },
            br: { x: this.x + (this.vertical ? 0 : this.length), y: this.y + (this.vertical ? this.length : 0) }
        };
    }
}
